import { createStyles, makeStyles, Theme } from '@material-ui/core';

const useStyles = makeStyles((theme: Theme) => createStyles({
  tableComponent: {
    width: '100%',
    fontSize: '16px',
    letterSpacing: '0.05em',
    lineHeight: '24px',
    color: '#1a1a1a',
    [theme.breakpoints.down('sm')]: {
      fontSize: '12px',
      letterSpacing: '0.28px',
      lineHeight: '18px',
    },
  },
  tableComponent_Wrapper: {
    paddingBottom: '1.25em',
    paddingTop: '1.875em',
  },
  tableComponent_Wrapper_dl: {
    borderTop: '1px solid #a8a8a8',
    display: 'flex',
    margin: 0,
    padding: 0,
    '&:last-child': {
      borderBottom: '1px solid #a8a8a8',
    },
  },
  tableComponent_Wrapper_dt: {
    backgroundColor: '#EBEBEB',
    padding: '1em',
    width: '32%',
    textAlign: 'center',
    display: 'table',
    boxSizing: 'border-box',
    fontWeight: 600,
  },
  tableComponent_Wrapper_dd: {
    width: '68%',
    padding: '1em',
    display: 'table',
    boxSizing: 'border-box',
    marginLeft: '0px',
  },
  tableComponent_Wrapper_title: {
    display: 'table-cell',
    verticalAlign: 'middle',
    textAlign: 'center',
  },
  tableComponent_Wrapper_content: {
    display: 'table-cell',
    verticalAlign: 'middle',
  },
  optionComponent: {
    fontWeight: 'normal',
    display: 'block',
    whiteSpace: 'nowrap',
    minHeight: '1.2em',
    padding: ' 0px 2px 1px',
  },

}));

export default useStyles;
